import { render, staticRenderFns } from "./ArrivalRejection.vue?vue&type=template&id=34cbaf96"
import script from "./ArrivalRejection.vue?vue&type=script&lang=js"
export * from "./ArrivalRejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports